import { useCases } from "../../providers/Cases";
import { usePosts } from "../../providers/Posts";
import { BackButton } from "./backLinkStyle";

const BackLink = () => {
  const { setShowCases, setShowCaseDesc } = useCases();
  const { setShowPost } = usePosts();

  const back = () => {
    setShowCases(false);
    setShowCaseDesc(false);
    setShowPost(false);
  };
  return <BackButton onClick={() => back()}> {"<"} Voltar</BackButton>;
};

export default BackLink;
